// src/utils/validationUtils.js

/**
 * Validates the form fields for the submission.
 * @param {Object} fields - The form fields to validate.
 * @returns {Object} - An object containing the validation errors, if any.
 */
export const validateSubmissionFields = (fields) => {
  const errors = {};

  // Check if the title is empty
  if (!fields.title || fields.title.trim() === "") {
    errors.title = "Title is required.";
  }

  // Check if the description is empty
  if (!fields.description || fields.description.trim() === "") {
    errors.description = "Description is required.";
  }

  // Check if the funding goal is a valid number
  if (
    !fields.fundingGoal ||
    isNaN(fields.fundingGoal) ||
    Number(fields.fundingGoal) <= 0
  ) {
    errors.fundingGoal = "Funding goal must be a positive number.";
  }

  return errors;
};
